var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "full-width no-padding-top",
      attrs: { id: "profile-update" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "form",
              { attrs: { id: "profile-form", enctype: "multipart/form-data" } },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "first_name" } }, [
                    _vm._v("First name")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.first_name,
                        expression: "profile.first_name"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "first_name",
                      placeholder: "First name"
                    },
                    domProps: { value: _vm.profile.first_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "first_name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "last_name" } }, [
                    _vm._v("Last name")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.last_name,
                        expression: "profile.last_name"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "last_name",
                      placeholder: "Last name"
                    },
                    domProps: { value: _vm.profile.last_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "last_name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "user_email" } }, [
                    _vm._v("Your email")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.user_email,
                        expression: "profile.user_email"
                      }
                    ],
                    attrs: {
                      type: "text",
                      name: "user_email",
                      placeholder: "Email"
                    },
                    domProps: { value: _vm.profile.user_email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.profile, "user_email", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "user_password" } }, [
                    _vm._v("Change your password")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.profile.user_password,
                        expression: "profile.user_password"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "user_password",
                      placeholder: "Password"
                    },
                    domProps: { value: _vm.profile.user_password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.profile,
                          "user_password",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "core-btn",
                    attrs: { disabled: _vm.thinking },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.saveDetails.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Save my details")]
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row heading" }, [
      _c("div", { staticClass: "col-12" }, [_c("h2", [_vm._v("My profile")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }